export default function debounce(func: (...args: any[]) => void, delay: number): (...args: any[]) => void {
    let timeoutHandle: number;
    return function (...args: any[]): void {
        // @ts-ignore
        let self: any = this;
        clearTimeout(timeoutHandle);
        timeoutHandle = window.setTimeout(() => {
            func.apply(self, args);
        }, delay);
    };
}
